import ApiService from './api.service'

const UsersService = {    
  get(userId, companyId, withRoles, userName, roleNames, isLockOut, page, count) {
    return ApiService.get('api/users', {
      params: {
        UserId: userId,
        CompanyId: companyId,
        WithRoles: withRoles,
        UserName: userName,
        RoleNames: roleNames,
        IsLockOut: isLockOut,
        Page: page,
        Count: count
      }
    })
  },

  create(user) {
    return ApiService.post('api/users', user)
  },

  update(user) {
    return ApiService.put('api/users', user)
  },

  delete(userId) {
    return ApiService.delete(`api/users/${userId}`)
  },

  setPassword(userData) {
    return ApiService.put('api/users/set-password', userData)
  },

  lockUnlock(userData) {
    return ApiService.put('/api/users/lock-unlock', userData)
  },

  getRoles() {
    return ApiService.get('api/users/roles')
  },

  getEnergyTypes(id) {
    return ApiService.get('api/users/energy-types', {
      params: {
        Id: id,            
      }
    })
  },

  getUserProjects(userId, notInUser, page, count) {
    return ApiService.get('/api/users/user-projects', {
      params: {
        UserId: userId,
        NotInUser: notInUser,
        Page: page,
        Count: count
      }
    })
  },

  addUserProject(userProject) {
    return ApiService.put('/api/users/add-project', userProject)
  },

  removeUserProject(userProject) {
    return ApiService.put('/api/users/remove-project', userProject)
  },

  getUserNodes(userId, notInUser, page, count) {
    return ApiService.get('/api/users/user-nodes', {
      params: {
        UserId: userId,
        NotInUser: notInUser,
        Page: page,
        Count: count
      }
    })
  },

  addUserNode(userNode) {
    return ApiService.put('/api/users/add-node', userNode)
  },

  removeUserNode(userNode) {
    return ApiService.put('/api/users/remove-node', userNode)
  },
}

export default UsersService